export default {
  name: 'KDatePickerWeek',
  inject: ['context'],
  provide() {
    return {}
  },
  props: {
    weekOfYear: {
      type: Number,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {},
  render() {
    const css = {
      'km-date-picker__week': true,
    }

    const data = {
      class: css,
    }

    return (
      <div {...data}>
        {this.$slots.default}
      </div>
    )
  },
}
